<template>
  <div
    class="border border-gray-300 hover:border-gray-500 px-2 py-1 rounded-lg flex justify-center items-center gap-2"
  >
    <div @click="handleView('list')">
      <i
        class=" fas fa-bars cursor-pointer"
        :class="getSelectedView === 'list' ? 'text-gray-900' : 'text-gray-400'"
      ></i>
    </div>
    <div @click="handleView('grid')">
      <i
        class=" fas fa-grip-vertical cursor-pointer"
        :class="getSelectedView === 'grid' ? 'text-gray-900' : 'text-gray-400'"
      ></i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MultipleTableViewButton',
  props: {
    selectedView: {
      type: String,
      default: 'grid',
    },
  },
  computed: {
    getSelectedView() {
      return this.selectedView
    },
  },
  methods: {
    handleView(view) {
      this.$emit('change', view)
    },
  },
}
</script>
<style lang=""></style>
